import { render } from "./FormTemplate.vue?vue&type=template&id=6ecb6623&scoped=true&ts=true"
import script from "./FormTemplate.vue?vue&type=script&lang=ts"
export * from "./FormTemplate.vue?vue&type=script&lang=ts"

import "./FormTemplate.vue?vue&type=style&index=0&id=6ecb6623&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ecb6623"]])

export default __exports__